import { ClaimRewardRequest, ClaimStatus, ClaimWindow } from 'types/claim';
import moment from 'moment';
import { DATE_TIME_FORMAT } from 'data/constant';

export const getRewardStatus = (rewardWindow: ClaimWindow): ClaimStatus => {
	const now = Math.floor(Date.now() / 1000);

	if (now < rewardWindow.windowStart) {
		const claimStartDate = moment(
			new Date(rewardWindow.windowStart * 1000),
		).format(DATE_TIME_FORMAT);

		const claimEndDate = moment(
			new Date(rewardWindow.windowEnd * 1000),
		).format(DATE_TIME_FORMAT);
		return {
			text: `You can claim reward between ${claimStartDate} - ${claimEndDate}`,
			isOpen: false,
		};
	} else if (
		now >= rewardWindow.windowStart &&
		now <= rewardWindow.windowEnd
	) {
		return {
			text: '',
			isOpen: true,
		};
	} else {
		return {
			text: '',
			isOpen: false,
		};
	}
};

export const hasCreationWithinWindow = (
	claims: ClaimRewardRequest[],
	window: ClaimWindow,
): boolean => {
	return claims.some((claim) => {
		if (!claim.createdAt) return false; // Skip if createdAt is not defined

		const createdAtTimestamp = Date.parse(claim.createdAt) / 1000;

		return (
			createdAtTimestamp >= window.windowStart &&
			createdAtTimestamp <= window.windowEnd
		);
	});
};

export const isDateLiesInTheWindow = (
	date: string,
	window: ClaimWindow,
): boolean => {
	const createdAtTimestamp = Date.parse(date) / 1000;

	return (
		createdAtTimestamp >= window.windowStart &&
		createdAtTimestamp <= window.windowEnd
	);
};

export const isWithinClaimWindow = (claimWindow: ClaimWindow): boolean => {
	const nowSec = Math.floor(Date.now() / 1000);

	return nowSec >= claimWindow.windowStart && nowSec <= claimWindow.windowEnd;
};

export const isDateWithinClaimWindow = (
	claimWindow: ClaimWindow,
	dateToCheck?: string | Date,
): boolean => {
	const ms = dateToCheck
		? typeof dateToCheck === 'string'
			? new Date(dateToCheck).getTime()
			: dateToCheck.getTime()
		: Date.now();

	const sec = Math.floor(ms / 1000);
	return sec >= claimWindow.windowStart && sec <= claimWindow.windowEnd;
};
